import { useState, useEffect } from "react";
import axios from "axios";

const API = "/api";

const C = {
  rust:"#9d4931",  rustD:"#7a3524",  rustL:"#c4613f",
  terra:"#b9714b", sage:"#a7c4b0",   fern:"#69735a",
  fernD:"#4e5743", creme:"#eee2d2",  cremeD:"#e0d0ba",
  grey:"#ccc8bc",  greyD:"#9e9a8e",  white:"#ffffff",
  text:"#2c2420",  muted:"#6b5f58",
};

const S = {
  input:{padding:"9px 12px",borderRadius:8,border:`1.5px solid ${C.grey}`,fontSize:13,color:C.text,background:C.white,outline:"none",boxSizing:"border-box",width:"100%"},
  card:{background:C.white,borderRadius:12,padding:"22px 24px",border:`1px solid ${C.cremeD}`,marginBottom:20},
  th:{padding:"9px 12px",textAlign:"left",fontSize:11,fontWeight:700,color:C.fern,textTransform:"uppercase",letterSpacing:"0.5px",borderBottom:`2px solid ${C.cremeD}`,whiteSpace:"nowrap"},
  td:{padding:"11px 12px",borderBottom:`1px solid ${C.creme}`,color:C.text,verticalAlign:"middle"},
  btnPrimary:{padding:"9px 22px",borderRadius:8,border:"none",background:C.rust,color:C.white,fontSize:13,fontWeight:600,cursor:"pointer"},
  btnOutline:{padding:"7px 16px",borderRadius:8,border:`1.5px solid ${C.grey}`,background:C.white,fontSize:12,color:C.muted,cursor:"pointer"},
  btnDanger:{padding:"5px 12px",borderRadius:6,border:"none",fontSize:12,fontWeight:600,cursor:"pointer",background:"#fdf0ed",color:C.rust},
  btnSuccess:{padding:"5px 12px",borderRadius:6,border:"none",fontSize:12,fontWeight:600,cursor:"pointer",background:"#eef4f1",color:C.fern},
  btnGhost:{padding:"5px 12px",borderRadius:6,border:"none",fontSize:12,fontWeight:600,cursor:"pointer",background:C.creme,color:C.text},
  tag:(r)=>({display:"inline-block",padding:"2px 10px",borderRadius:20,fontSize:11,fontWeight:700,textTransform:"uppercase",letterSpacing:"0.4px",background:r==="admin"?"#f5ede9":"#eef4f1",color:r==="admin"?C.rust:C.fern}),
  label:{display:"block",fontSize:11,fontWeight:700,color:C.fern,marginBottom:5,textTransform:"uppercase",letterSpacing:"0.5px"},
  err:{background:"#fdf0ed",border:`1px solid ${C.terra}`,color:C.rust,borderRadius:8,padding:"9px 13px",fontSize:13,marginBottom:14},
  info:{background:"#eef4f1",border:`1px solid ${C.sage}`,color:C.fernD,borderRadius:8,padding:"9px 13px",fontSize:13,marginBottom:14},
};

function LogoMark({ size=38 }) {
  return (
    <div style={{width:size,height:size,borderRadius:size*0.24,background:C.rust,display:"flex",alignItems:"center",justifyContent:"center",color:C.white,fontWeight:800,fontSize:size*0.42,letterSpacing:"-0.5px",flexShrink:0}}>
      V7
    </div>
  );
}

function Topbar({ username, role, onLogout, subtitle }) {
  return (
    <div style={{background:C.white,borderBottom:`1px solid ${C.cremeD}`,padding:"0 28px",height:56,display:"flex",alignItems:"center",justifyContent:"space-between",position:"sticky",top:0,zIndex:20}}>
      <div style={{display:"flex",alignItems:"center",gap:10}}>
        <LogoMark size={34} />
        <div>
          <div style={{fontWeight:700,fontSize:14,color:C.rust,lineHeight:1.2}}>V7 AI Solutions</div>
          <div style={{fontSize:11,color:C.muted}}>{subtitle}</div>
        </div>
      </div>
      <div style={{display:"flex",alignItems:"center",gap:10}}>
        <span style={{fontSize:13,color:C.muted}}>{username}</span>
        <span style={S.tag(role)}>{role}</span>
        <button style={S.btnOutline} onClick={onLogout}>Sign out</button>
      </div>
    </div>
  );
}

function QRModal({ userId, deviceName, onClose }) {
  const [config, setConfig] = useState("");
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    axios.get(`${API}/users/${userId}/devices/${deviceName}/config/text`)
      .then(r => setConfig(r.data.config))
      .catch(() => setConfig("Config not found"));
  }, [userId, deviceName]);

  const qrUrl = config
    ? `https://api.qrserver.com/v1/create-qr-code/?size=240x240&data=${encodeURIComponent(config)}`
    : "";

  const copy = () => {
    navigator.clipboard.writeText(config);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div onClick={onClose} style={{position:"fixed",inset:0,zIndex:100,background:"rgba(44,36,32,0.6)",display:"flex",alignItems:"center",justifyContent:"center",padding:16}}>
      <div onClick={e => e.stopPropagation()} style={{background:C.white,borderRadius:16,padding:"28px 28px 24px",width:460,maxWidth:"100%",maxHeight:"90vh",overflowY:"auto",boxShadow:"0 8px 48px rgba(157,73,49,0.18)"}}>
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:20}}>
          <div>
            <div style={{fontWeight:700,fontSize:16,color:C.rust}}>VPN Config</div>
            <div style={{fontSize:12,color:C.muted,marginTop:2}}>{deviceName}</div>
          </div>
          <button onClick={onClose} style={{...S.btnOutline,fontSize:16,padding:"2px 10px"}}>x</button>
        </div>
        <div style={{background:C.creme,borderRadius:12,padding:20,textAlign:"center",marginBottom:18,border:`1px solid ${C.cremeD}`}}>
          {qrUrl
            ? <img src={qrUrl} alt="WireGuard QR" style={{borderRadius:8,display:"block",margin:"0 auto"}} />
            : <div style={{height:240,display:"flex",alignItems:"center",justifyContent:"center",color:C.greyD}}>Generating QR...</div>
          }
          <div style={{fontSize:12,color:C.muted,marginTop:12}}>Scan with <strong>WireGuard</strong> mobile app</div>
        </div>
        <pre style={{background:"#2c2420",color:"#eee2d2",borderRadius:8,padding:"14px 16px",fontSize:11,overflowX:"auto",maxHeight:160,margin:"0 0 16px",lineHeight:1.6}}>
          {config || "Loading..."}
        </pre>
        <div style={{display:"flex",gap:10}}>
          <a href={`${API}/users/${userId}/devices/${deviceName}/config`} download style={{textDecoration:"none",flex:1}}>
            <button style={{...S.btnPrimary,width:"100%"}}>Download .conf</button>
          </a>
          <button style={{...S.btnOutline,flex:1}} onClick={copy}>
            {copied ? "Copied!" : "Copy config"}
          </button>
        </div>
      </div>
    </div>
  );
}

function EditUserModal({ user, onClose, onSaved }) {
  const [form, setForm] = useState({ username:user.username, email:user.email||"", role:user.role });
  const [err,  setErr]  = useState("");
  const [saving, setSaving] = useState(false);

  const save = async () => {
    setSaving(true); setErr("");
    try {
      await axios.patch(`${API}/users/${user.id}`, form);
      onSaved();
      onClose();
    } catch(e) {
      setErr(e.response?.data?.error || "Update failed");
    } finally { setSaving(false); }
  };

  return (
    <div onClick={onClose} style={{position:"fixed",inset:0,zIndex:100,background:"rgba(44,36,32,0.6)",display:"flex",alignItems:"center",justifyContent:"center",padding:16}}>
      <div onClick={e => e.stopPropagation()} style={{background:C.white,borderRadius:16,padding:"28px",width:420,maxWidth:"100%",boxShadow:"0 8px 48px rgba(157,73,49,0.18)"}}>
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:20}}>
          <div style={{fontWeight:700,fontSize:16,color:C.rust}}>Edit user</div>
          <button onClick={onClose} style={{...S.btnOutline,fontSize:16,padding:"2px 10px"}}>x</button>
        </div>
        {err && <div style={S.err}>⚠ {err}</div>}
        <label style={S.label}>Username</label>
        <input style={{...S.input,marginBottom:12}} value={form.username}
          onChange={e => setForm({...form,username:e.target.value})} />
        <label style={S.label}>Email</label>
        <input style={{...S.input,marginBottom:12}} type="email" value={form.email}
          onChange={e => setForm({...form,email:e.target.value})} />
        <label style={S.label}>Role</label>
        <select style={{...S.input,marginBottom:20}} value={form.role}
          onChange={e => setForm({...form,role:e.target.value})}>
          <option value="user">user</option>
          <option value="admin">admin</option>
        </select>
        <div style={{display:"flex",gap:10}}>
          <button style={{...S.btnPrimary,flex:1}} onClick={save} disabled={saving}>
            {saving ? "Saving..." : "Save changes"}
          </button>
          <button style={{...S.btnOutline,flex:1}} onClick={onClose}>Cancel</button>
        </div>
      </div>
    </div>
  );
}

function StatCard({ value, label, accent=false }) {
  return (
    <div style={{background:accent?C.rust:C.white,borderRadius:12,padding:"20px 22px",border:`1px solid ${accent?C.rustD:C.cremeD}`}}>
      <div style={{fontSize:36,fontWeight:800,lineHeight:1,color:accent?C.creme:C.rust}}>{value ?? "—"}</div>
      <div style={{fontSize:12,marginTop:5,color:accent?C.cremeD:C.muted}}>{label}</div>
    </div>
  );
}

const DEVICE_ICONS = { laptop:"💻", phone:"📱", tablet:"📟", desktop:"🖥️", other:"🔌" };

export default function App() {
  const [token,     setToken]     = useState("");
  const [role,      setRole]      = useState("");
  const [userId,    setUserId]    = useState(null);
  const [username,  setUsername]  = useState("");
  const [users,     setUsers]     = useState([]);
  const [stats,     setStats]     = useState(null);
  const [me,        setMe]        = useState(null);
  const [newUser,   setNewUser]   = useState({ username:"", email:"", role:"user" });
  const [newDevice, setNewDevice] = useState({});
  const [error,     setError]     = useState("");
  const [loading,   setLoading]   = useState(false);
  const [qrTarget,  setQrTarget]  = useState(null);
  const [editUser,  setEditUser]  = useState(null);
  const [expandedUser, setExpandedUser] = useState(null);

  useEffect(() => {
    const p   = new URLSearchParams(window.location.search);
    const t   = p.get("token");
    const r   = p.get("role");
    const u   = p.get("username");
    const err = p.get("error");
    if (err) {
      setError(err === "not_registered"
        ? "Your Google account is not registered. Please contact your administrator."
        : "Google sign-in failed. Try again.");
      window.history.replaceState({}, "", "/");
      return;
    }
    if (t) {
      localStorage.setItem("token",    t);
      localStorage.setItem("role",     r || "user");
      localStorage.setItem("username", decodeURIComponent(u || ""));
      window.history.replaceState({}, "", "/");
      applyToken(t, r || "user", decodeURIComponent(u || ""));
      return;
    }
    const st = localStorage.getItem("token");
    if (st) applyToken(st, localStorage.getItem("role")||"user", localStorage.getItem("username")||"");
  }, []);

  function applyToken(t, r, u) {
    axios.defaults.headers.common["Authorization"] = `Bearer ${t}`;
    setToken(t); setRole(r); setUsername(u);
  }

  useEffect(() => {
    if (!token) return;
    axios.get(`${API}/me`).then(r => { setMe(r.data); setUserId(r.data.id); }).catch(() => {});
    if (role === "admin") { loadUsers(); loadStats(); }
  }, [token, role]);

  const loadStats  = () => axios.get(`${API}/stats`).then(r => setStats(r.data)).catch(() => {});
  const loadUsers  = () => axios.get(`${API}/users`).then(r => setUsers(r.data)).catch(() => {});
  const refreshAll = () => { loadUsers(); loadStats(); };

  const logout = () => {
    localStorage.clear();
    delete axios.defaults.headers.common["Authorization"];
    setToken(""); setRole(""); setUsername(""); setUsers([]); setStats(null); setMe(null);
  };

  const createUser = async () => {
    setError("");
    if (!newUser.username || !newUser.email) { setError("Username and email required"); return; }
    try {
      await axios.post(`${API}/users`, newUser);
      setNewUser({ username:"", email:"", role:"user" });
      refreshAll();
    } catch(e) { setError(e.response?.data?.error || "Create failed"); }
  };

  const deleteUser = async (id, uname) => {
    if (!window.confirm(`Delete "${uname}" and ALL their devices + VPN configs?`)) return;
    await axios.delete(`${API}/users/${id}`);
    refreshAll();
  };

  const addDevice = async (userId, username) => {
    const device_name = newDevice[userId];
    if (!device_name) return;
    setError("");
    try {
      await axios.post(`${API}/users/${userId}/devices`, { device_name });
      setNewDevice(d => ({ ...d, [userId]:"" }));
      loadUsers();
    } catch(e) { setError(e.response?.data?.error || "Add device failed"); }
  };

  const deleteDevice = async (userId, deviceName) => {
    if (!window.confirm(`Delete device "${deviceName}"?`)) return;
    await axios.delete(`${API}/users/${userId}/devices/${deviceName}`);
    loadUsers(); loadStats();
  };

  // ── LOGIN ────────────────────────────────────────────────────────────────────
  if (!token) {
    return (
      <div style={{display:"flex",alignItems:"center",justifyContent:"center",minHeight:"100vh",background:C.creme,fontFamily:"'Segoe UI',system-ui,sans-serif"}}>
        <div style={{background:C.white,borderRadius:16,padding:"40px 36px",width:420,maxWidth:"95vw",boxShadow:"0 4px 32px rgba(157,73,49,0.13)",border:`1px solid ${C.cremeD}`}}>
          <div style={{display:"flex",alignItems:"center",gap:12,marginBottom:32}}>
            <LogoMark size={46} />
            <div>
              <div style={{fontSize:20,fontWeight:800,color:C.rust,letterSpacing:"-0.3px"}}>V7 AI Solutions</div>
              <div style={{fontSize:12,color:C.muted,marginTop:2}}>VPN Access Portal</div>
            </div>
          </div>
          <h2 style={{margin:"0 0 6px",fontSize:22,fontWeight:700,color:C.text}}>Welcome</h2>
          <p style={{margin:"0 0 24px",fontSize:13,color:C.muted}}>Sign in with your Google account to continue.</p>
          {error && (
            <div style={{...S.err,marginBottom:20}}>
              ⚠ {error}
            </div>
          )}
          <a href="/api/auth/google" style={{textDecoration:"none"}}>
            <button style={{...S.btnPrimary,width:"100%",padding:"14px 0",fontSize:15,display:"flex",alignItems:"center",justifyContent:"center",gap:12}}>
              <svg width="20" height="20" viewBox="0 0 48 48" style={{flexShrink:0}}>
                <path fill="#FFC107" d="M43.6 20H24v8h11.3C33.6 33.1 29.3 36 24 36c-6.6 0-12-5.4-12-12s5.4-12 12-12c3 0 5.8 1.1 7.9 2.9l5.7-5.7C34.1 6.5 29.3 4 24 4 12.9 4 4 12.9 4 24s8.9 20 20 20c11 0 19.7-8 19.7-20 0-1.3-.1-2.7-.1-4z"/>
                <path fill="#FF3D00" d="M6.3 14.7l6.6 4.8C14.5 15.1 18.9 12 24 12c3 0 5.8 1.1 7.9 2.9l5.7-5.7C34.1 6.5 29.3 4 24 4 16.3 4 9.7 8.3 6.3 14.7z"/>
                <path fill="#4CAF50" d="M24 44c5.2 0 9.9-1.9 13.5-5l-6.2-5.2C29.4 35.5 26.8 36 24 36c-5.2 0-9.6-2.9-11.8-7.1l-6.5 5C9.5 39.6 16.2 44 24 44z"/>
                <path fill="#1976D2" d="M43.6 20H24v8h11.3c-.9 2.4-2.5 4.4-4.6 5.8l6.2 5.2C40.8 35.5 44 30.2 44 24c0-1.3-.1-2.7-.4-4z"/>
              </svg>
              Continue with Google
            </button>
          </a>
          <p style={{fontSize:11,color:C.greyD,textAlign:"center",marginTop:20,lineHeight:1.6}}>
            Only pre-registered accounts can sign in.<br/>Contact your administrator if you need access.
          </p>
        </div>
      </div>
    );
  }

  // ── USER VIEW ────────────────────────────────────────────────────────────────
  if (role !== "admin") {
    return (
      <div style={{minHeight:"100vh",background:C.creme,fontFamily:"'Segoe UI',system-ui,sans-serif"}}>
        <Topbar username={username} role={role} onLogout={logout} subtitle="VPN Portal" />
        <div style={{maxWidth:600,margin:"36px auto",padding:"0 20px"}}>
          <div style={S.card}>
            <div style={{display:"flex",alignItems:"center",gap:14,marginBottom:20}}>
              <div style={{width:48,height:48,borderRadius:12,background:C.sage,display:"flex",alignItems:"center",justifyContent:"center",fontSize:22,fontWeight:700,color:C.fernD}}>
                {username?.[0]?.toUpperCase()||"U"}
              </div>
              <div>
                <div style={{fontWeight:700,fontSize:16,color:C.text}}>{username}</div>
                <span style={S.tag(role)}>{role}</span>
              </div>
            </div>
            {me && [["Email",me.email||"—"],["Auth",me.auth_type],["Member since",me.created_at?.slice(0,10)]].map(([k,v]) => (
              <div key={k} style={{display:"flex",justifyContent:"space-between",padding:"10px 0",borderBottom:`1px solid ${C.creme}`,fontSize:13}}>
                <span style={{color:C.muted,fontWeight:600}}>{k}</span>
                <span style={{color:C.text}}>{v}</span>
              </div>
            ))}
          </div>

          <div style={S.card}>
            <div style={{fontWeight:700,fontSize:15,color:C.text,marginBottom:16}}>My Devices</div>
            {me?.devices?.length === 0 && (
              <div style={{...S.info}}>No devices assigned yet. Contact your administrator.</div>
            )}
            {me?.devices?.map(d => (
              <div key={d.id} style={{display:"flex",alignItems:"center",justifyContent:"space-between",padding:"12px 0",borderBottom:`1px solid ${C.creme}`}}>
                <div style={{display:"flex",alignItems:"center",gap:10}}>
                  <span style={{fontSize:20}}>{DEVICE_ICONS[d.device_name] || "🔌"}</span>
                  <div>
                    <div style={{fontWeight:600,fontSize:14,color:C.text,textTransform:"capitalize"}}>{d.device_name}</div>
                    <code style={{fontSize:11,color:C.muted}}>{d.vpn_ip}</code>
                  </div>
                </div>
                <div style={{display:"flex",gap:8}}>
                  <button style={S.btnPrimary} onClick={() => setQrTarget({userId:me.id,deviceName:d.device_name})}>
                    📱 QR
                  </button>
                  <a href={`${API}/users/${me.id}/devices/${d.device_name}/config`} download style={{textDecoration:"none"}}>
                    <button style={S.btnOutline}>⬇ .conf</button>
                  </a>
                </div>
              </div>
            ))}
          </div>
        </div>
        {qrTarget && <QRModal userId={qrTarget.userId} deviceName={qrTarget.deviceName} onClose={() => setQrTarget(null)} />}
      </div>
    );
  }

  // ── ADMIN VIEW ───────────────────────────────────────────────────────────────
  return (
    <div style={{minHeight:"100vh",background:C.creme,fontFamily:"'Segoe UI',system-ui,sans-serif"}}>
      <Topbar username={username} role={role} onLogout={logout} subtitle="Admin Dashboard" />
      <div style={{maxWidth:1080,margin:"0 auto",padding:"28px 20px"}}>

        <div style={{display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:16,marginBottom:24}}>
          <StatCard value={stats?.total_users}   label="Total users" />
          <StatCard value={stats?.total_devices} label="Total VPN devices" />
          <StatCard value={stats?.admin_users}   label="Admins" accent={true} />
        </div>

        <div style={S.card}>
          <div style={{fontWeight:700,fontSize:15,color:C.text,marginBottom:16}}>Add new user</div>
          {error && <div style={S.err}>⚠ {error}</div>}
          <div style={{display:"flex",gap:10,flexWrap:"wrap",alignItems:"flex-end"}}>
            <div style={{display:"flex",flexDirection:"column",flex:2,minWidth:160}}>
              <label style={S.label}>Username</label>
              <input style={S.input} placeholder="john" value={newUser.username}
                onChange={e => setNewUser({...newUser,username:e.target.value})} />
            </div>
            <div style={{display:"flex",flexDirection:"column",flex:3,minWidth:200}}>
              <label style={S.label}>Google email</label>
              <input style={S.input} type="email" placeholder="john@gmail.com" value={newUser.email}
                onChange={e => setNewUser({...newUser,email:e.target.value})} />
            </div>
            <div style={{display:"flex",flexDirection:"column",minWidth:110}}>
              <label style={S.label}>Role</label>
              <select style={S.input} value={newUser.role}
                onChange={e => setNewUser({...newUser,role:e.target.value})}>
                <option value="user">User</option>
                <option value="admin">Admin</option>
              </select>
            </div>
            <button style={{...S.btnPrimary,alignSelf:"flex-end"}} onClick={createUser}>
              + Add user
            </button>
          </div>
          <div style={{fontSize:12,color:C.muted,marginTop:10}}>
            User will be able to sign in with their Google account after being added here.
          </div>
        </div>

        <div style={S.card}>
          <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:16}}>
            <div style={{fontWeight:700,fontSize:15,color:C.text}}>
              All users <span style={{color:C.greyD,fontWeight:400}}>({users.length})</span>
            </div>
            <button style={S.btnOutline} onClick={refreshAll}>↻ Refresh</button>
          </div>

          {users.length === 0 && (
            <div style={{color:C.muted,fontSize:13,padding:"12px 0"}}>No users yet</div>
          )}

          {users.map(u => (
            <div key={u.id} style={{border:`1px solid ${C.cremeD}`,borderRadius:10,marginBottom:12,overflow:"hidden"}}>
              <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",padding:"14px 16px",background:expandedUser===u.id?C.creme:C.white,cursor:"pointer"}}
                onClick={() => setExpandedUser(expandedUser===u.id ? null : u.id)}>
                <div style={{display:"flex",alignItems:"center",gap:12}}>
                  <div style={{width:36,height:36,borderRadius:9,background:u.role==="admin"?`${C.rust}22`:`${C.sage}55`,display:"flex",alignItems:"center",justifyContent:"center",fontSize:15,fontWeight:700,color:u.role==="admin"?C.rust:C.fernD,flexShrink:0}}>
                    {u.username?.[0]?.toUpperCase()}
                  </div>
                  <div>
                    <div style={{fontWeight:700,fontSize:14,color:C.text}}>{u.username}</div>
                    <div style={{fontSize:12,color:C.muted}}>{u.email||"—"}</div>
                  </div>
                </div>
                <div style={{display:"flex",alignItems:"center",gap:10}}>
                  <span style={{fontSize:12,color:C.muted,background:C.creme,padding:"2px 8px",borderRadius:10}}>
                    {u.devices?.length||0} device{u.devices?.length!==1?"s":""}
                  </span>
                  <span style={S.tag(u.role)}>{u.role}</span>
                  <button style={S.btnGhost} onClick={e => { e.stopPropagation(); setEditUser(u); }}>Edit</button>
                  <button style={S.btnDanger} onClick={e => { e.stopPropagation(); deleteUser(u.id,u.username); }}>Delete</button>
                  <span style={{color:C.greyD,fontSize:16}}>{expandedUser===u.id?"▲":"▼"}</span>
                </div>
              </div>

              {expandedUser === u.id && (
                <div style={{padding:"16px",borderTop:`1px solid ${C.cremeD}`,background:C.white}}>
                  <div style={{fontWeight:600,fontSize:13,color:C.text,marginBottom:12}}>
                    Devices ({u.devices?.length||0} / 3)
                  </div>

                  {u.devices?.length === 0 && (
                    <div style={{...S.info,marginBottom:12}}>No devices yet. Add one below.</div>
                  )}

                  {u.devices?.map(d => (
                    <div key={d.id} style={{display:"flex",alignItems:"center",justifyContent:"space-between",padding:"10px 12px",background:C.creme,borderRadius:8,marginBottom:8}}>
                      <div style={{display:"flex",alignItems:"center",gap:10}}>
                        <span style={{fontSize:18}}>{DEVICE_ICONS[d.device_name]||"🔌"}</span>
                        <div>
                          <div style={{fontWeight:600,fontSize:13,color:C.text,textTransform:"capitalize"}}>{d.device_name}</div>
                          <code style={{fontSize:11,color:C.muted}}>{d.vpn_ip}</code>
                        </div>
                      </div>
                      <div style={{display:"flex",gap:8}}>
                        <button style={S.btnSuccess} onClick={() => setQrTarget({userId:u.id,deviceName:d.device_name})}>
                          📱 QR
                        </button>
                        <a href={`${API}/users/${u.id}/devices/${d.device_name}/config`} download style={{textDecoration:"none"}}>
                          <button style={S.btnGhost}>⬇ .conf</button>
                        </a>
                        <button style={S.btnDanger} onClick={() => deleteDevice(u.id,d.device_name)}>
                          Remove
                        </button>
                      </div>
                    </div>
                  ))}

                  {(u.devices?.length||0) < 3 && (
                    <div style={{display:"flex",gap:8,marginTop:12,alignItems:"center"}}>
                      <select
                        style={{...S.input,width:"auto",flex:1}}
                        value={newDevice[u.id]||""}
                        onChange={e => setNewDevice(d => ({...d,[u.id]:e.target.value}))}>
                        <option value="">Select device type</option>
                        <option value="laptop">💻 Laptop</option>
                        <option value="phone">📱 Phone</option>
                        <option value="tablet">📟 Tablet</option>
                        <option value="desktop">🖥️ Desktop</option>
                        <option value="other">🔌 Other</option>
                      </select>
                      <button style={S.btnPrimary} onClick={() => addDevice(u.id,u.username)}>
                        + Add device
                      </button>
                    </div>
                  )}
                  {(u.devices?.length||0) >= 3 && (
                    <div style={{fontSize:12,color:C.greyD,marginTop:8}}>Maximum 3 devices reached.</div>
                  )}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>

      {qrTarget && <QRModal userId={qrTarget.userId} deviceName={qrTarget.deviceName} onClose={() => setQrTarget(null)} />}
      {editUser  && <EditUserModal user={editUser} onClose={() => setEditUser(null)} onSaved={loadUsers} />}
    </div>
  );
}
